<span #content [matTooltip]="tooltip">{{ text }}</span>
